/**
 * Whether firing `action` on an item needs a non-blank comment. The server decides it per
 * FSM transition and lists such actions in `comment_required_actions`; the client only
 * reads that list, so a new rule needs no client change.
 */
export function isCommentRequiredFor(
  item: { comment_required_actions?: string[] } | null | undefined,
  action: string,
): boolean {
  return (item?.comment_required_actions ?? []).includes(action);
}
